module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }